import { useEffect, useState, Fragment } from "react";
import styles from "./LoanApproval.module.scss";
import { useDispatch, useSelector } from "react-redux";
import { IoIosArrowBack, IoIosArrowRoundForward } from "react-icons/io";
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import { useTheme } from "@mui/material/styles";

// components

// methods
import useResponse from "../../hooks/useResponse";
import AfterOnboardAPI from "../../services/AfterOnboardAPI";
import FinboxAPI from "../../services/finbox.api";
import { addAccountId, addUpgradeLoanAmount, changeLoanApproved, setStepperDisable } from "../../redux/slices/userSlice";
import { useNavigate } from "react-router-dom";
import { googleEvent_LOJ091, googleEvent_LOJ094, googleEvent_LOJ226 } from "../../lib/google-analytics";
import { pixelEvents } from "../../lib/pixel-events";
import { addLoanAmount } from "../../redux/slices/registerSlice";
import EMIDetails from "./components/EMIDetails/EMIDetails";
import { CustomButton } from "../../components";
import EMIsAPI from "../../services/emi-api";
import { handlehideContextualLoader, handleShowContextualLoader } from "../../utils/contextualLoaderTrigger";
import ApprovedBankAccount from "./components/ApprovedBankAccount/ApprovedBankAccount";
import { loanPurposeListItem } from "../../Constants/constant";
import api from "../../utils/api";
import { API_URL } from "../../utils/environment";
import { MdModeEdit, MdClose } from "react-icons/md";
import { ORDER_ID_LOCAL_STORAGE_KEY } from "../../Constants/constant";


export default function LoanApproval() {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);
  const [bankData, setBankData] = useState(null);
  const [loanPurpose, setLoanPurpose] = useState("");
  const [toggleDrawer, setToggleDrawer] = useState(false);
  const { accountId } = useSelector((state) => state.user);
  const {selectedLoan} = useSelector((state) => state.register);

  const dispatch = useDispatch();
  const theme = useTheme();

  // const location = useLocation();
  const navigate = useNavigate();

  const emiData = selectedLoan || {};

  const { confirmBankAccountAPI } = new AfterOnboardAPI();
  const { finboxcreateUrlAPI } = new FinboxAPI();
  const { paydayToEMIConversionAPI } = new EMIsAPI();

  const { handleStep } = useResponse();

  useEffect(() => {
    dispatch(changeLoanApproved(true));
    dispatch(setStepperDisable(true));
    handleFetchAPI();
  }, [dispatch]);

  useEffect(() => {
    localStorage.removeItem(ORDER_ID_LOCAL_STORAGE_KEY);
  }, []);

  const handleFetchAPI = async () => {
    const { loanApprovedAPI } = new AfterOnboardAPI();
    const res = await loanApprovedAPI(emiData);
    if (res && res.statusCode === 200) {
      setData(res.data);
      setLoanPurpose(res.data.loanPurpose);
      if (res.data.totalAmount) {
        googleEvent_LOJ091();
        pixelEvents.approvedProcess();
      }

      dispatch(addLoanAmount(res.data.totalAmount));
    }
    setLoading(false);
  };

  const handleUpgradeLoanAmount = async () => {
    setLoading(true);
    handleShowContextualLoader("Please wait...")
    const res = await finboxcreateUrlAPI();
    if (res) {
      dispatch(addUpgradeLoanAmount());

      googleEvent_LOJ226();
      window.location.href = res.data.redirect_url;
    }
    handlehideContextualLoader();
    setLoading(false);
  };

  const handlePaydayToEMIConversion = async () => {
    setLoading(true);
    const res = await paydayToEMIConversionAPI(emiData);

    if (res.statusCode === 200 && data.leadType !== "Repeat Case") {
      handleStep(accountId);
    }
    setLoading(false);
  };

  const handleConfirmBankAccount = async () => {
    const { mandateId, accountID } = bankData;

    const res = await confirmBankAccountAPI(mandateId, accountID);

    if (res && res.statusCode === 200) {
      dispatch(addAccountId(accountID));
      handleStep(accountID);
    }
  };

  const handleUpdateLoanPurpose = async () => {
    try {
      const endpoint = API_URL + "/customers/incompleteDetailsUpdate";
      const req = {
        purposeloan:loanPurpose,
        leadID: Number(localStorage.getItem("leadID")),
        repeat: true,
      };

      const { data } = await api.put(endpoint, req);
    } catch (error) {
      console.log(error);
    }
  };

  if (!data) return null;

  const processingAndGst = () => {
    return (
      <div className="fw-600">
        {data?.isSpecialOffer ? (
          <strike className={styles.strikAmount}>
            ₹{(data?.processingAmountBeforeDiscount + data?.gstOfAdminFeeBeforeDiscount)?.toLocaleString("en-IN")}
          </strike>
        ) : null}
        -₹{(data?.processingAmount + data?.gstOfAdminFee)?.toLocaleString("en-IN")}
      </div>
    );
  };

  return (
    <div className={styles.loanApprovalStyle}>
      <div>
        {/* Top Header */}
        <div className={styles.topHeader}>
          {/* <div className={styles.backButton} onClick={() => (window.location.href = "/dashboard")}>
            <IoIosArrowBack size={34} color="#ffffff" />
          </div> */}
          <div className={styles.message}>
            <p className={styles.firstText}>
              <span className="fw-600">Special Offer!</span> Only For You
            </p>
          </div>
          <div className={styles.bgImage} />
        </div>

        {/* Loan Approved */}
        <div className={styles.loanApproved}>
          <h3>Loan Approved</h3>
          <div className={styles.images}>
            <img src="/images/hand-holding.svg" alt="" />
          </div>
          <p>You have been approved for a loan of amount</p>
          <h2>₹{data?.totalAmount.toLocaleString("en-IN")}</h2>

          <div className={styles.amountDetails}>
            <div>Approved amount</div>
            <div className="fw-700">₹{data?.totalAmount.toLocaleString("en-IN")}</div>
          </div>
          <div className={styles.amountDetails}>
            <div>Processing fee +GST</div>
            {Object.keys(data).length ? processingAndGst() : null}
          </div>
          <div className={`${styles.amountDetails} ${styles.finalAmount}`}>
            <div>Final loan amount</div>
            <div className="fw-600">₹{data?.finalAmount.toLocaleString("en-IN")}</div>
          </div>

          {data?.isLoanAmountUpgradable && emiData.ProductID === 2 && (
            <div className={styles.upgradeAmount} onClick={() => handleUpgradeLoanAmount()}>
              Upgrade my Loan Amount
            </div>
          )}
        </div>

        {/* Bank Account details */}
        <ApprovedBankAccount leadType={data.leadType} setBankData={setBankData} />

         {/* Loan Purpose */}
         {
          data?.leadType === 'Repeat Case' && data?.loanPurpose ? <div className={styles.loanPurpose}>
          <h4>Loan Purpose</h4>
          <div>{loanPurpose} <MdModeEdit className={styles.editIcon} size={20} onClick={() => setToggleDrawer(!toggleDrawer)} /></div>
          </div> : null
         }

        {/* Repayment Plan */}
        <div className={styles.repaymentPlan}>
          <h4>Repayment plan</h4>

          {emiData.ProductID === 1 ? (
            <EMIDetails emiData={data?.emiStructure} />
          ) : (
            <div className={styles.repaymentBlock}>
              <div className={styles.left}>
                <div className={styles.title}>Repayment Date</div>
                <div className={styles.value}>
                  {new Date(data?.repayDate).toDateString()} <span className={styles.days}>{data?.tenure} days</span>
                </div>
              </div>
              <div className={styles.right}>
                <div className={styles.title}>Repayment Amount</div>
                <div className={styles.value}>
                  {data?.isSpecialOffer ? (
                    <strike className={styles.strikAmount}>₹{data?.totalRepaymentAmountBeforeDiscount.toLocaleString("en-IN")}</strike>
                  ) : null}
                  ₹{data?.repayAmount.toLocaleString("en-IN")}
                </div>
              </div>
            </div>
          )}
        </div>

      </div>

      {/* Total Amount */}
      <div className={styles.totalAmount}>
        <div>
          <p>Total</p>
          <h5>₹{data?.totalAmount.toLocaleString("en-IN")}</h5>
          <span className={styles.taxText}>Inclusive of all taxes</span>
        </div>
        <div>
          <CustomButton
            floating={false}
            text="Continue"
            endIcon={<IoIosArrowRoundForward size={32} />}
            onClick={() => {
              if(data.loanPurpose !== loanPurpose){
                handleUpdateLoanPurpose();
              }
              if (emiData.ProductID === 1) {
                handlePaydayToEMIConversion();
              } else {
                if (data.leadType !== "Repeat Case" && !bankData) handleStep(accountId);
              }

              if (bankData) {
                handleConfirmBankAccount();
              }

              dispatch(setStepperDisable(false));

              // Events
              googleEvent_LOJ094();
            }}
          />
        </div>
      </div>
      <Fragment>
          <SwipeableDrawer
            className={styles.loanPurposeBottomSheet}
            anchor="bottom"
            open={toggleDrawer}
            sx={{
            "& .MuiDrawer-paper": {
              maxWidth: 480,
              width: "100%",
              margin: "0 auto",
              left: "0",
              [theme.breakpoints.up("sm")]: {
                left: 0,
              },
              display: "flex",
              flexDirection: "column",
              maxHeight: "85vh",
            },
          }}
          >
            <div className={styles.title}>
              <h4>Select Loan Purpose</h4>
              <MdClose size={24} className={styles.closeIcon} onClick={() => setToggleDrawer(false)} />
            </div>
            {loanPurposeListItem.map((item, index) => (
              <div key={index} className={`${styles.listItem} ${item === loanPurpose ? styles.selected : ''}`} onClick={() => {
                setLoanPurpose(item);
                setToggleDrawer(false); 
              }} >
                {item}
              </div>
            ))}
          </SwipeableDrawer>
        </Fragment>
    </div>
  );
}
